import { gtagEnabled } from './index'
import { LineItem } from '@medusajs/medusa'
import { formatMedusaPrice } from '../formatMedusaPrice'

export const trackAddPaymentInfo = (items: LineItem[], paymentType: string, total: number) => {
    if (gtagEnabled()) {
        gtag('event', 'add_payment_info', {
            value: total,
            payment_type: paymentType,
            currency: 'EUR',
            items: items.map(item => {
                return {
                    item_name: item.title,
                    item_id: item.id,
                    quantity: item.quantity,
                    price: formatMedusaPrice(item.unit_price),
                }
            }),
        })
    }
}
